<template>
	<div class="animated fadeIn">


		<div class="row">
			<div class="col-xs-12 clearfix">

				<div class="pull-left f24">
					<i class="fa fa-fire text-success"></i>
					<span v-show="!article.editMode">发布文章</span>
					<span v-show="article.editMode">编辑文章</span>
				</div>
				<div class="pull-right">
					<CreateSaveButton :entity="article" :callback="save"/>
				</div>
			</div>
		</div>


		<div class="row">
			<div class="col-xs-12 m-t-md">


				<div class="form-group" v-if="article.type !== 'WEBSITE'">
					<label class="control-label">
						<span class="text-danger">*</span>
						类型
					</label><span class="italic">(普通文章主要用于给菜单项做链接。新闻会出现在首页的新闻列表中。)</span>
					<select class="form-control m-b" name="type" v-model="article.type">
						<option v-for="type in article.TypeList" v-if="type.value !== 'WEBSITE' " :value="type.value">
							{{type.name}}
						</option>
					</select>
				</div>


				<div class="form-group">
					<label class="control-label"><span class="text-danger">*</span>标题</label>
					<input type="text" class="form-control" v-model="article.title">
				</div>


				<div class="form-group clear">
					<label class="control-label">封面</label>
					<div>
						<NbTank :tank="article.poster"/>
					</div>

				</div>

				<div class="form-group">
					<label class="control-label"><span class="text-danger">*</span>作者</label>
					<input type="text" class="form-control" v-model="article.author">
				</div>
				<div class="form-group">
					<label class="control-label"><span class="text-danger">*</span>发布时间</label>
					<div>
						<el-date-picker
							v-model="article.releaseTime"
							type="datetime"
							placeholder="选择日期时间">
						</el-date-picker>
					</div>
				</div>
				<div class="form-group" v-if="false" v-show="article.type === 'NEWS' || article.id === 2">
					<label v-if="article.id !== 2" class="control-label">摘要(不填写摘要将自动截取正文前部分作为摘要)</label>
					<label v-if="article.id === 2" class="control-label">摘要(此处摘要将出现在首页轮播图左侧，建议200字以内)</label>
					<textarea class="form-control" rows="6" v-model="article.digest"
					          placeholder="此处填写文章摘要……"></textarea>
				</div>


				<div class="m-b-md" v-if="article.type !=='LINE_NEWS'">
					<label class="control-label"><span class="text-danger">*</span>正文</label>
					<div>
						<NbEditor v-model="article.content"/>
					</div>

				</div>

				<div class="form-group" v-if="article.type ==='LINE_NEWS'">
					<label class="control-label">链接（http:// 或 https:// 开头）</label>
					<input type="text" class="form-control" v-model="article.content">
				</div>


			</div>
			<div class="col-xs-12 m-t-md">
				<div class="alert alert-danger" v-show="article.errorMessage">
					{{article.errorMessage}}
				</div>
				<div class="pull-right">
					<CreateSaveButton :entity="article" :callback="save"/>
				</div>
			</div>
		</div>

	</div>

</template>
<script>
	import NbTag from '../../../common/widget/NbTag'
	import NbTank from '../../../common/widget/NbTank'
	import NbEditor from "../../../common/widget/NbEditor"
	import CreateSaveButton from "../widget/CreateSaveButton.vue"
	import {simpleDateTime, str2Date} from '../../../common/filter/time'
	import {Notification} from 'element-ui';
	import Article from '../../../common/model/article/Article'

	import {getErrorMessage} from '../../../common/util/Utils'
	import $ from "jquery"

	export default {

		data () {
			return {
				user: this.$store.state.user,
				article: new Article()
			}
		},
		components: {
			NbTag,
			NbTank,
			NbEditor,
			CreateSaveButton
		},
		computed: {},
		watch: {},
		methods: {
			save(){
				let that = this;
				this.article.httpSave(function (response) {

					Notification.success({
						message: that.article.editMode ? '修改文章成功！' : '创建文章成功！'
					});
					that.$router.push("/cgd/by/article/detail/" + that.article.id);

				});
			}
		},


		mounted(){

			let that = this;

			this.article.author = this.user.nickname;
			this.article.poster.privacy = false;

			this.article.id = this.$store.state.route.params.id;

			if (this.article.id) {

				this.article.editMode = true;
				this.article.httpDetail();
			}
		}
	}
</script>



// WEBPACK FOOTER //
// Create.vue?2db133f8